import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentModel } from 'src/environments/environmentModel';
import { decodeInBrowserText } from 'tools/obfuscate';
import { BrandingData } from '../branding.service';

@Injectable({ providedIn: 'root' })
export class ConfigService {
    public settings: EnvironmentModel;
    public brandingData: BrandingData | null = null;

    constructor(private http: HttpClient) { }

    /**
     * Define os dados de branding carregados da API
     * Deve ser chamado antes de loadConfig() no APP_INITIALIZER
     */
    public setBrandingData(data: BrandingData | null): void {
        this.brandingData = data;
        console.log('[ConfigService] Branding data set:', data);
    }

    async loadConfig(): Promise<void> {
        const path = `assets/env/env.json`;
        try {
            const configEncoded = await this.http.get(path, { responseType: 'text' }).toPromise();
            const decodedString = decodeInBrowserText(configEncoded);
            this.settings = JSON.parse(decodedString) as EnvironmentModel;

            // Merge branding data se existir
            this._mergeBrandingData();
        } catch (error) {
            console.error('❌ CONFIG: Erro ao carregar configurações:', error);
            console.warn('⚠️ CONFIG: Usando configurações padrão fallback');

            // Fallback - usar configurações básicas para evitar travamento
            this.settings = {
                clientName: '',
                features: {
                    sso: { enabled: false, logoutUrl: '', logoutByClient: false },
                    showNotifications: true,
                    tutorialMenu: true,
                    cannotOpenProfile: false,
                    principlesConfiguration: false
                },
                hideReports: false
            } as any;

        }
    }
    
    /**
     * Faz merge dos dados de branding com as configurações do env.json
     * Branding data tem prioridade sobre env.json
     */
    private _mergeBrandingData(): void {
        if (!this.brandingData) {
            return;
        }


        // Sobrescrever clientName se existir no branding
        if (this.brandingData.clientName) {
            const oldClientName = this.settings.clientName;
            this.settings.clientName = this.brandingData.clientName;
        }

    }
}
